<script setup lang="ts">
import type { IAffiliateDataFormSchema } from '@modules/affiliates-profile/types';
import type { FormResult } from '@modules/forms/components/VForm/types';
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VLoader from '@components/loader/VLoader.vue';
import { ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME } from '@modules/affiliates-approved/constants';
import { TRANSLATION_GROUP_AFFILIATE_PROFILE } from '@modules/affiliates-approved/submodules/affiliate-profile/constants';
import VForm from '@modules/forms/components/VForm/VForm.vue';

import type { IAffiliateProfileUpdateFormEmits, IAffiliateProfileUpdateFormProps } from './types';

defineProps<IAffiliateProfileUpdateFormProps>();
const emit = defineEmits<IAffiliateProfileUpdateFormEmits>();

function onChange(
  key: keyof IAffiliateDataFormSchema,
  value: IAffiliateDataFormSchema[keyof IAffiliateDataFormSchema],
  result: FormResult<IAffiliateDataFormSchema>,
): void {
  emit('change', result.values);
}

function onSubmit(values: IAffiliateDataFormSchema): void {
  emit('submit', values);
}

function onInteracted(key: string): void {
  emit('interacted', key);
}
</script>

<template>
  <VLoader v-data-qa-auto-id="'VAffiliateProfileUpdateForm'"
    :loading="isDataLoading"
    min-height="200px"
  >
    <VForm
      :schema="formSchema"
      :submit-btn-label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROFILE, 'SETTINGS_SAVE_BTN')"
      :readonly="readonly"
      :is-loading="isUpdateLoading"
      :custom-errors="errors"
      @change="onChange"
      @submit="onSubmit"
      @interacted="onInteracted"
    >
      <template #secondaryBtn>
        <VBackButton
          :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROFILE, 'SETTINGS_BACK_BTN')"
          :to="{
            name: ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME,
          }"
        />
      </template>
    </VForm>
  </VLoader>
</template>
